var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { IconButton, InputAdornment, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
var CopyAdornment = function (_a) {
    var value = _a.value;
    var t = useTranslation().t;
    var _b = useState(false), tooltipOpen = _b[0], setTooltipOpen = _b[1];
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    var timeoutRef = useRef(null);
    var copyToClipboard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(value)];
                case 2:
                    _a.sent();
                    setCopied(true);
                    setTooltipOpen(true);
                    if (timeoutRef.current)
                        clearTimeout(timeoutRef.current);
                    timeoutRef.current = window.setTimeout(function () {
                        setTooltipOpen(false);
                        // reset text AFTER close animation
                        setTimeout(function () { return setCopied(false); }, 200);
                    }, 3000);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error('Failed to copy', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (!value)
        return null;
    return (_jsx(InputAdornment, __assign({ position: "end", sx: {
            cursor: 'pointer',
            '.MuiOutlinedInput-root.Mui-disabled &': {
                cursor: 'pointer',
            },
            '& .MuiIconButton-root, & .MuiSvgIcon-root': {
                cursor: 'pointer',
            },
            '.MuiOutlinedInput-root.Mui-disabled & .MuiIconButton-root, .MuiOutlinedInput-root.Mui-disabled & .MuiSvgIcon-root': {
                cursor: 'pointer',
            },
        } }, { children: _jsx(Tooltip, __assign({ title: copied ? t('Copied') : t('Copy to clipboard'), open: tooltipOpen, onOpen: function () { return setTooltipOpen(true); }, onClose: function () {
                if (!copied)
                    setTooltipOpen(false);
            }, arrow: true, placement: "top" }, { children: _jsx(IconButton, __assign({ "aria-label": t('Copy to clipboard'), edge: "end", onClick: copyToClipboard, size: "small", sx: { mr: '-0.66rem', cursor: 'pointer' }, onMouseEnter: function () { return !copied && setTooltipOpen(true); }, onMouseLeave: function () { return !copied && setTooltipOpen(false); } }, { children: _jsx(ContentCopyIcon, { fontSize: "small" }) })) })) })));
};
export default CopyAdornment;
